import { render } from "./CardPayoutOnboarding.vue?vue&type=template&id=fe7c47d2&scoped=true"
import script from "./CardPayoutOnboarding.vue?vue&type=script&lang=js"
export * from "./CardPayoutOnboarding.vue?vue&type=script&lang=js"

import "./CardPayoutOnboarding.vue?vue&type=style&index=0&id=fe7c47d2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe7c47d2"]])

export default __exports__